import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toastr } from "react-redux-toastr";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { DropdownList } from "react-widgets";
import { Customer, Address } from "../../../../core/api/models";
import api from "../../../../api";
import Countries from "../../../../utils/countries.json";
import States from "../../../../utils/states.json";
import { addressType, contactStatus } from "../../../../core/api/models/customer";

const SearchCustomer: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateUser: (details: Customer) => void;
  selectedAddress?: Address;
  customerDetails?: Customer;
}> = (props) => {
  const [isAddressPrimary, setAddressPrimary] = useState<boolean>(
    props && props.selectedAddress ? props.selectedAddress.isPrimary : false
  );
  const { control, handleSubmit, errors, watch, setValue } = useForm<Customer>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const [districtList, setDistrictList] = useState([]);

  const statesList = watch("country") === "India" || !props.selectedAddress?.country ? States : [];

  const [isSubmiting, setIsSubmiting] = useState<boolean>(false);

  const setAsPrimary = () => {
    setAddressPrimary(!isAddressPrimary);
  };

  const onSubmit = async (data?: any) => {
    setIsSubmiting(true);
    let addresses =
      props.customerDetails && props.customerDetails?.addresses
        ? props.customerDetails?.addresses
        : [];
    if (props && props.selectedAddress) {
      addresses = addresses.filter((x) => x._id !== props.selectedAddress?._id);
    }

    addresses.push({
      _id: props.selectedAddress?._id,
      // houseName: data?.houseName,
      // houseNumber: data?.houseNumber,
      country: data?.country,
      state: data?.state,
      district: data?.district,
      city: data?.city,
      address: data?.address,
      postalCode: data?.postalCode,
      isPrimary: false,
      addressType: data?.addressType,
      // remarks: data?.remarks,
      contactStatus: data?.contactStatus,
    });
    const updateData: Customer = {
      addresses,
    };
    try {
      const response = await api.customer.updateCustomer(updateData, props.customerDetails?._id);
      props.updateUser(response);
      props.onClose();
      toastr.success("Success", "Address saved successfully");
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error("Error", error?.response?.data?.data?.message.join());
      } else {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
    setIsSubmiting(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="bg-gray-100 border-top border-bottom py-3">
        <div className="px-4">
          <h6 className="font-weight-semibold">Add New Address</h6>
        </div>
        {/* <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            House Name<span className="text-danger">*</span>
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              rules={{
                required: true,
                validate: (value) => {
                  return !!value.trim();
                },
              }}
              name="houseName"
              defaultValue={props.selectedAddress?.houseName}
              render={({ onChange, value, name }) => (
                <input
                  type="text"
                  className="form-control rounded-sm font-weight-semibold"
                  placeholder="House Name"
                  name={name}
                  value={value}
                  onChange={onChange}
                  id="houseName"
                />
              )}
            />
            {errors.houseName && (
              <ErrorMessage>
                {errors.houseName.type === "required"
                  ? "House Name is required"
                  : "Invalid House Name"}
              </ErrorMessage>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            House Number<span className="text-danger">*</span>
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              rules={{
                required: true,
                validate: (value) => {
                  return !!value.trim();
                },
              }}
              name="houseNumber"
              defaultValue={props.selectedAddress?.houseNumber}
              render={({ onChange, value, name }) => (
                <input
                  type="text"
                  className="form-control rounded-sm font-weight-semibold"
                  placeholder="House Number"
                  name={name}
                  value={value}
                  onChange={onChange}
                  id="houseNumber"
                />
              )}
            />
            {errors.houseNumber && (
              <ErrorMessage>
                {errors.houseNumber.type === "required"
                  ? "House Number is required"
                  : "Invalid House Number"}
              </ErrorMessage>
            )}
          </div>
        </div> */}
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            Country
            {/* <span className="text-danger">*</span> */}
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{ required: true }}
              name="country"
              defaultValue={props.selectedAddress?.country || "India"}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={Countries}
                  textField={"name"}
                  valueField={"name"}
                  placeholder={"Select country"}
                  onChange={(val) => {
                    onChange(val.name);
                  }}
                  filter={"contains"}
                />
              )}
            />
            {errors.country && (
              <ErrorMessage>
                {errors.country.type === "required" ? "Country is required" : "Invalid Country"}
              </ErrorMessage>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            State 
            {/* <span className="text-danger">*</span> */}
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{ required: true }}
              name="state"
              defaultValue={props.selectedAddress?.state}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={statesList}
                  textField={"state"}
                  valueField={"state"}
                  placeholder={"Select state"}
                  onChange={(val) => {
                    onChange(val.state);
                    setDistrictList(val.districts);
                  }}
                />
              )}
            />
            {errors.state && (
              <ErrorMessage>
                {errors.state.type === "required" ? "State is required" : "Invalid State"}
              </ErrorMessage>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            District 
             {/* <span className="text-danger">*</span> */}
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{ required: true }}
              name="district"
              defaultValue={props.selectedAddress?.district}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={districtList?.map((d) => {
                    return {
                      name: d,
                    };
                  })}
                  textField={"name"}
                  valueField={"name"}
                  placeholder={"Select district"}
                  onChange={(val) => {
                    onChange(val.name);
                  }}
                />
              )}
            />
            {errors.district && (
              <ErrorMessage>
                {errors.district.type === "required" ? "District is required" : "Invalid District"}
              </ErrorMessage>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            {" "}
            Address
             {/* <span className="text-danger">*</span>{" "} */}
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{ required: true }}
              name="address"
              defaultValue={props.selectedAddress?.address}
              render={({ onChange, value, name }) => (
                <textarea
                  rows={2}
                  className="form-control rounded-sm font-weight-semibold"
                  placeholder=" Address"
                  name={name}
                  value={value}
                  onChange={onChange}
                  id="address"
                />
              )}
            />
            {errors.address && (
              <ErrorMessage>
                {errors.address.type === "required" ? " Address is required" : "Invalid  Address"}
              </ErrorMessage>
            )}
          </div>
        </div>

        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            City
            {/* <span className="text-danger">*</span> */}
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{
              //   required: true,
              //   validate: (value) => {
              //     return !!value.trim();
              //   },
              // }}
              name="city"
              defaultValue={props.selectedAddress?.city}
              render={({ onChange, value, name }) => (
                <input
                  type="text"
                  className="form-control rounded-sm font-weight-semibold"
                  placeholder="City"
                  name={name}
                  value={value}
                  onChange={onChange}
                  id="city"
                />
              )}
            />
            {errors.city && (
              <ErrorMessage>
                {errors.city.type === "required" ? "City is required" : "Invalid City"}
              </ErrorMessage>
            )}
          </div>
        </div>

        {/* <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            Governorate
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              name="governorate"
              defaultValue={props.selectedAddress?.governorate}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={governorates}
                  textField={"name"}
                  valueField={"name"}
                  placeholder={"Select Governorate"}
                  onChange={(val) => {
                    onChange(val.name);
                    setValue("district", "");
                    setValue("otherDistrict", "");
                  }}
                />
              )}
            />
            {errors.governorate && (
              <ErrorMessage>
                {errors.governorate.type === "required"
                  ? "Governorate is required"
                  : "Invalid Governorate"}
              </ErrorMessage>
            )}
          </div>
        </div>
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            District
          </div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              name="district"
              defaultValue={
                props.selectedAddress?.isOtherDistrict
                  ? "Other"
                  : props.selectedAddress?.district
              }
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={districts?.map((key) => {
                    return {
                      name: key,
                    };
                  })}
                  textField={"name"}
                  valueField={"name"}
                  placeholder={"Select District"}
                  onChange={(val) => {
                    onChange(val.name);
                    setValue("otherDistrict", "");
                  }}
                />
              )}
            />
          </div>
        </div> */}
        {/* {district === "Other" && (
          <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
            <div className="col pl-0 pr-2 contact-label font-xs text-gray-500"></div>
            <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
              <Controller
                control={control}
                name="otherDistrict"
                rules={{ required: true }}
                defaultValue={props.selectedAddress?.district}
                render={({ onChange, value, name }) => (
                  <input
                    type="text"
                    className="form-control rounded-sm font-weight-semibold"
                    placeholder="Enter district"
                    name={name}
                    value={value}
                    onChange={onChange}
                    id="otherDistrict"
                  />
                )}
              />
              {errors.district && (
                <ErrorMessage>
                  {errors.district.type === "required"
                    ? "District is required"
                    : "Invalid District"}
                </ErrorMessage>
              )}
            </div>
          </div>
        )} */}
        <div className="d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline">
          <div className="col pl-0 pr-2 contact-label font-xs text-gray-500">Zip code</div>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{
              //   required: true,
              //   validate: (value) => {
              //     return !!value.trim();
              //   },
              // }}
              // rules={{
              //   required: false,
              //   pattern: {
              //     value: /^[0-9]{6}$/,
              //     message: "Invalid Postal Code",
              //   },
              // }}
              name="postalCode"
              defaultValue={props.selectedAddress?.postalCode}
              render={({ onChange, value, name }) => (
                <input
                  type="text"
                  className="form-control rounded-sm font-weight-semibold"
                  placeholder="Postal Code"
                  name={name}
                  value={value}
                  onChange={onChange}
                  id="postalCode"
                />
              )}
            />
            {errors.postalCode && (
              <ErrorMessage>
                {errors.postalCode.type === "required"
                  ? "Postal Code is required"
                  : "Invalid Postal Code"}
              </ErrorMessage>
            )}
          </div>
        </div>

        <div className={`d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline`}>
          <label htmlFor="" className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            Address Type
            {/* <span className="text-danger">*</span> */}
          </label>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{ required: true }}
              name="addressType"
              defaultValue={props.selectedAddress?.addressType}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={addressType}
                  textField={"name"}
                  valueField={"value"}
                  placeholder={"Select address Type"}
                  onChange={(val) => {
                    onChange(val.value);
                  }}
                />
              )}
            />
            {errors.addressType && <ErrorMessage>Address Type is required</ErrorMessage>}
          </div>
        </div>

        <div className={`d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline`}>
          <label htmlFor="" className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            Contact Status
          </label>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              // rules={{ required: false }}
              name="contactStatus"
              defaultValue={props.selectedAddress?.contactStatus}
              render={({ onChange, value, name }) => (
                <DropdownList
                  value={value}
                  defaultValue={value}
                  data={contactStatus}
                  textField={"name"}
                  valueField={"value"}
                  placeholder={"Select contact status"}
                  onChange={(val) => {
                    onChange(val.value);
                  }}
                />
              )}
            />
            {errors.contactStatus && <ErrorMessage>Contact Status is required</ErrorMessage>}
          </div>
        </div>
        {/* <div className={`d-flex flex-wrap px-4 py-1 contact-form-row active align-items-baseline`}>
          <label htmlFor="" className="col pl-0 pr-2 contact-label font-xs text-gray-500">
            Remarks
          </label>
          <div className="col pl-2 pr-0 contact-content d-flex flex-wrap align-items-center">
            <Controller
              control={control}
              name="remarks"
              defaultValue={props.selectedAddress?.remarks}
              render={({ onChange, value, name }) => (
                <textarea
                  rows={2}
                  className="form-control rounded-sm font-weight-semibold"
                  placeholder="Remarks"
                  name={name}
                  value={value}
                  onChange={onChange}
                  id="remarks"
                />
              )}
            />
            {errors.remarks && <ErrorMessage>remarks is required</ErrorMessage>}
          </div>
        </div> */}
        <div className="col-12 px-4 mt-2 text-right">
          <div className="px-2">
            <button
              className="btn btn-sm btn-outline-dark mr-1 font-normal"
              onClick={props.onClose}
            >
              Cancel
            </button>
            <button disabled={isSubmiting} className="btn btn-sm btn-primary font-normal">
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default SearchCustomer;
